const inititalState = {
  paymentList: [],
  totalAmountOwed: null,
  totalAmountPaid: null,
}

export default function payments(state = inititalState, action) {
  switch(action.type) {
    case 'FETCH_PAYMENTS_RESPONSE':
      return {...state, paymentList: action.payload}
    case 'FETCH_PAYMENT_TOTALS_RESPONSE':
      return {...state, totalAmountOwed: action.payload.total_amount_owed, totalAmountPaid: action.payload.total_amount_paid}
    case 'DELETE_PAYMENT_RESPONSE':
      return {...state, paymentList: state.paymentList.filter(payment => payment.id !== action.payload)}
    default: 
      return state
  }
}
